<template>
  <div>
    <v-container>
      <v-layout row>
        <v-flex xs6>
          <v-btn @click="back" text class="text_btn">
            <v-icon>keyboard_arrow_left</v-icon>back
          </v-btn>
        </v-flex>
        <v-flex xs6 style="text-align:right;"></v-flex>
      </v-layout>
      <h1>
        <v-icon style="padding-bottom:5px;">poll</v-icon>
        Data explorer ({{ b_name }})
      </h1>
      <v-expansion-panels style="margin-top:30px;">
        <v-expansion-panel>
          <v-expansion-panel-header ref="expansion_header_credentials" expand-icon="expand_more">
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col cols="4">Credentials</v-col>
                <v-col cols="8" class="text--secondary">
                  <v-fade-transition leave-absolute>
                    <span v-if="open" key="0">Enter credentials</span>
                    <span v-else key="1">{{ app_id && app_secret ? "All set" : "Not set" }}</span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p>
              For testing purposes, create in the app manager a new client and copy the credentials here.
              The credentials will be saved locally, once you have typed them here.
            </p>
            <v-layout row wrap>
              <v-flex sm12 md6 xs12 style="padding:10px;">
                <v-text-field label="App ID" v-model="app_id" />
                <v-text-field label="App Secret" v-model="app_secret" />
              </v-flex>
              <v-flex sm12 md6 xs12 style="padding:10px;">
                <v-text-field label="Auth token (optional)" v-model="auth_token" />
                <div style="float:right;">
                  <v-btn @click="getLastAppIdAndSecret" style="margin-right:10px;">
                    <i class="fal fa-file-import" style="margin-right:5px;"></i> Get app credentials
                  </v-btn>
                  <v-btn @click="connect">
                    <v-icon>save</v-icon>Save
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header
            ref="expansion_header_container_dataset"
            expand-icon="expand_more"
          >
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col cols="4">Container and dataset</v-col>
                <v-col cols="8" class="text--secondary">
                  <v-fade-transition leave-absolute>
                    <span v-if="open" key="0">Enter container and dataset</span>
                    <span
                      v-else
                      key="1"
                    >{{ container == "" ? "Not set" : container.split("|")[1] + " / " + dataset }}</span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p>Define the container and a dataset. You cannot fetch dataset with an auth token.</p>
            <v-layout row wrap>
              <v-flex style="padding:10px;" xs12 sm12 md6>
                <v-select
                  v-model="container"
                  :items="available_containers"
                  label="Container"
                  item-text="name"
                  item-value="id"
                />
              </v-flex>
              <v-flex style="padding:10px;" xs12 sm12 md6>
                <v-text-field label="Dataset" @keydown="enterLoad" :autocomplete="true" v-model="dataset" />
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header
            ref="expansion_header_filters"
            expand-icon="expand_more"
          >
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col cols="4">Filters</v-col>
                <v-col cols="8" class="text--secondary">
                  <v-fade-transition leave-absolute>
                    <span v-if="open" key="0"></span>
                    <span
                      v-else
                      key="1"
                    >{{ filters.length == 0 ? "Not set" : filters.length + " filter(s) set" }}</span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p>You can define here some new filters, which should be applied for the results below.</p>
            <FilterContainer @newfilters="updateFilters"/>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-layout>
        <v-flex>
          <v-btn @click="load" :loading="l_load" style="float:right;margin-top:20px;margin-bottom:20px;">
            <v-icon>refresh</v-icon>Load
          </v-btn>
        </v-flex>
      </v-layout>
      <div class="result" v-if="columns.length > 0">
        <v-data-table :headers="header" @click:row="editRow" :items="data_datatable" class="clickableTable">
          <template slot="no-data">
            <div>
              No data available in container
              <i>{{ container.split('|')[1] }}</i> and dataset
              <i>{{ dataset }}</i>
            </div>
          </template>
          <template v-slot:item.id="{ item }">
            <i>{{ item.id }}</i>
          </template>
        </v-data-table>
        <div style="margin-top:20px;float:right;">
          <v-btn @click="exportData" style="margin-right:10px;">
            <i class="fal fa-file-csv" style="margin-right:5px;"></i>Export CSV</v-btn>
          <v-btn @click="addDataPrepare">
            <i class="fal fa-plus" style="margin-right:5px;"></i>add row
          </v-btn>
        </div>
      </div>
    </v-container>

    <!-- Add data dialog -->
    <v-dialog v-model="d_add_data" width="500">
      <v-card>
        <v-form @submit="add_data">
          <v-card-title class="headline" primary-title>
            Add data in&nbsp;
            <b>{{ container.split("|")[1] }}</b>
          </v-card-title>

          <v-card-text>
            <p>
              Adds a new row with data in the container
              <i>{{ container.split("|")[1] }}</i> with the dataset
              <i>{{ dataset }}</i>.
            </p>
            <v-text-field
              v-model="add_data[column]"
              :label="column"
              v-for="column in columns"
              @keydown="enterAddData"
              :key="column"
            />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text class="text_btn" type="button" @click="addData" :loading="l_add" style="margin-top:20px;">
              <i class="fal fa-save" style="margin-right:5px;"></i>
              Add
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Edit data dialog -->
    <v-dialog v-model="d_edit_data" width="500">
      <v-card>
        <v-form @submit="edit_data">
          <v-card-title class="headline" primary-title>
            Edit data in&nbsp;
            <b>{{ container.split("|")[1] }}</b>
          </v-card-title>

          <v-card-text>
            <p>
              Edits the selected row <i>{{ edit_data["id"] }}</i> in the container <i>{{ container.split("|")[1] }}</i> with dataset <i>{{ dataset }}</i>.
            </p>
            <v-text-field
              v-model="edit_data[column]"
              :label="column"
              v-for="column in columns"
              @keydown="enterEditData"
              :key="column"
            />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="error" text class="text_btn" type="button" @click="deleteData">
              <i class="fal fa-trash" style="margin-right:5px;"></i>
              Delete
            </v-btn>
            <v-btn color="primary" text class="text_btn" type="button" @click="duplicateData">
              <i class="fal fa-copy" style="margin-right:5px;"></i>
              Duplicate
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="default" text class="text_btn" type="button" @click="d_edit_data = false">Cancel</v-btn>
            <v-btn color="primary" text class="text_btn" type="button" @click="editData" :loading="l_edit">
              <i class="fal fa-save" style="margin-right:5px;"></i>
              Edit
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Delete data dialog -->
    <v-dialog v-model="d_delete_data" width="500">
      <v-card>
        <v-form @submit="edit_data">
          <v-card-title class="headline" primary-title>
            Delete data in&nbsp;
            <b>{{ container.split("|")[1] }}</b>
          </v-card-title>

          <v-card-text>
            <p>Are you sure, that you want to delete the complete row {{ delete_data.id }}.</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" text class="text_btn" type="button" @click="d_delete_data = false">Cancel</v-btn>
            <v-btn color="error" text class="text_btn" type="button" @click="deleteDataConfirm" :loading="l_delete">Delete</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as Vars from "../logic/Vars";
import { Columns } from "../logic/Columns";
import { Containers } from "../logic/Containers";
import { Buckets } from "../logic/Buckets";

import { Notifications } from "../notification";
import { sCStorage } from "schmucklicloud_storage";
import { Apps } from '../logic/Apps';

import FilterContainer from "../components/dataexplorer/FilterContainer";

export default {
  name: "DataExplorer",
  data() {
    return {
      storage: undefined,

      project_id: 0,

      app_id: "",
      app_secret: "",
      auth_token: "",

      container: "",
      dataset: "",

      filters: [],

      available_containers: [],

      // Data
      columns: [],
      data: [],

      add_data: {},
      edit_data: {},
      delete_data: {},

      b_name: "...",

      // Loaders
      l_load: false,
      l_add: false,
      l_edit: false,
      l_delete: false,

      // Dialogs
      d_add_data: false,
      d_edit_data: false,
      d_delete_data: false
    };
  },
  computed: {
    header() {
      var header = [{ text: "ID", value: "id" }];
      this.columns.forEach(function(column) {
        header.push({ text: column, value: column });
      });
      return header;
    },
    data_datatable() {
      var data = [];
      this.data.forEach(function(row) {
        row.data["id"] = row.id;
        data.push(row.data);
      });
      return data;
    }
  },
  async mounted() {
    var bucket = this.$route.params.id;
    this.app_id = window.localStorage.getItem(
      "data_explorer__" + bucket + "__app_id",
      this.app_id
    );
    this.app_secret = window.localStorage.getItem(
      "data_explorer__" + bucket + "__app_secret",
      this.app_secret
    );
    this.auth_token = window.localStorage.getItem(
      "data_explorer__" + bucket + "__auth_token",
      this.app_secret
    );

    this.initialize();

    //Load metadata of bucket
    this.project_id = parseInt(this.$route.params.project_id);

    var bucket_response = await Buckets.get(this.project_id, bucket);
    if (bucket_response.status === 200) this.b_name = bucket_response.body.name;

    this.loadContainers();
  },
  methods: {
    initialize() {
      this.storage = new sCStorage(this.app_id, this.app_secret, Vars.API_ENDPOINT + "/client_api/v1/data/");
      if (this.auth_token && this.auth_token !== "") {
        this.storage.setAuthToken(this.auth_token, true);
      }
    },
    connect() {
      var bucket = this.$route.params.id;

      //Save the app id and secret locally for future uses.
      window.localStorage.setItem(
        "data_explorer__" + bucket + "__app_id",
        this.app_id || ""
      );
      window.localStorage.setItem(
        "data_explorer__" + bucket + "__app_secret",
        this.app_secret || ""
      );
      window.localStorage.setItem(
        "data_explorer__" + bucket + "__auth_token",
        this.auth_token || ""
      );

      Notifications.show("The credentials has been saved successfully.");

      this.initialize();
    },
    closeAllPanels() {
      var credentials = this.$refs["expansion_header_credentials"];
      var container_dataset = this.$refs["expansion_header_container_dataset"];
      if (container_dataset.isActive) {
        container_dataset.$el.click();
      }
      if (credentials.isActive) {
        credentials.$el.click();
      }
    },
    async getLastAppIdAndSecret() {
      var response_all_apps = await Apps.load(this.project_id);
      if (response_all_apps.status === 200) {
        var response = await Apps.get(response_all_apps.body[(response_all_apps.body.length - 1)].id);
        if (response.status === 200) {
          this.app_id = response.body.app_key;
          this.app_secret = response.body.app_secret;
          this.connect();
        } else {
          Notifications.show("There was a problem while retrieving the last app from the current project id.");
        }
      } else {
        Notifications.show("There was an error while retrieving the apps from the current project.");
      }
    },
    exportData() {
      var data = "";
      this.header.forEach(function(column) {
        data += column.text + ",";
      });
      data += "\n";

      this.data_datatable.forEach(function(row) {
        data += row.id + ",";
        for (var prop in row) {
          if (prop === "id") {
            continue;
          }
          data += row[prop] + ",";
        }
        data += "\n";
      });

      var encoded_data = btoa(data);

      var a = document.createElement("a"); //Create <a>
      a.href = "data:text/csv;base64," + encoded_data; //Image Base64 Goes here
      a.download = this.container + ".csv"; //File name Here
      a.click();
    },
    editRow(row) {
      this.d_edit_data = true;

      this.edit_data["id"] = row.id;
      
      this.columns.forEach(function(column) {
        this.edit_data[column] = row[column];
      }.bind(this));
    },
    deleteData() {
      this.d_delete_data = true;
      this.delete_data.id = this.edit_data.id;
    },
    enterLoad(e) {
      if (e.keyCode == 13) {
        this.load();
      }
    },
    enterAddData(e) {
      if (e.keyCode == 13) {
        this.addData();
      }
    },
    enterEditData(e) {
      if (e.keyCode == 13) {
        this.editData();
      }
    },
    updateFilters(filters) {
      this.filters = filters;
    },
    async load() {
      this.l_load = true;
      this.closeAllPanels();

      var bucket = this.$route.params.id;

      if (this.app_id === "" || this.app_secret === "") {
        Notifications.show("Please define an app id and secret.");
      } else if (
        bucket == undefined ||
        this.container == undefined ||
        this.container == ""
      ) {
        Notifications.show("Please define at least a container.");
      } else {
        this.storage.setBucket(bucket);
        this.storage.setDataset(this.dataset);

        var columns = await Columns.load(this.container.split("|")[0]);
        this.columns = [];
        if (columns.body) {
          columns.body.forEach(
            function(column) {
              this.columns.push(column.name);
            }.bind(this)
          );
        } else {
          Notifications.show(columns.response);
        }
        
        var response;
        if (this.filters.length === 0) {
          response = await this.storage.getAll(this.container.split("|")[1]);
        } else {
          response = await this.storage.get(this.container.split("|")[1], this.filters);
        }

        if (response.status_code === 200 && response.data) {
          this.data = response.data;
        } else if (
          response.status_code === 200 &&
          response.data === undefined
        ) {
          Notifications.show("The container with this dataset is empty.");
          this.data = [];
        } else {
          Notifications.show(response.message);
        }
      }

      this.l_load = false;
    },
    async loadContainers() {
      var bucket = this.$route.params.id;
      var response = await Containers.load(bucket);

      if (response.status === 200) {
        var available_containers = response.body;
        available_containers.forEach(function(container, index) {
          available_containers[index].id = container.id + "|" + container.name;
        });

        this.available_containers = available_containers;
      }
    },
    addDataPrepare() {
      // Clear all the fields
      this.columns.forEach(
        function(column) {
          this.add_data[column] = "";
        }.bind(this)
      );

      this.d_add_data = true;
    },
    async addData() {
      this.l_add = true;

      var data_object = {};

      this.columns.forEach(
        function(column) {
          data_object[column] = this.add_data[column] || "";
        }.bind(this)
      );

      var response = await this.storage.insert(
        this.container.split("|")[1],
        data_object
      );
      if (response.status_code === 200) {
        Notifications.show("The data has been added.");

        this.columns.forEach(
          function(column) {
            this.add_data[column] = "";
          }.bind(this)
        );

        this.d_add_data = false;
        this.load();
      } else {
        Notifications.show(response.message);
      }

      this.l_add = false;
    },
    duplicateData() {
      this.d_add_data = true;

      // Copy the data from the edit panel to the add panel
      this.columns.forEach(
        function(column) {
          this.add_data[column] = this.edit_data[column];
        }.bind(this)
      );

      this.d_edit_data = false;
      this.d_delete_data = false;
      this.d_add_data = true;
    },
    async deleteDataConfirm() {
      this.l_delete = true;

      var response = await this.storage.delete(this.container.split("|")[1], this.delete_data.id);

      if (response.status_code === 200) {
        Notifications.show("The row has been deleted.");

        this.d_delete_data = false;
        this.d_edit_data = false;

        this.load();
      } else {
        Notifications.show(response.message);
      }

      this.l_delete = false;
    },
    async editData() {
      this.l_edit = true;

      var data = {};
      this.columns.forEach(function (column) {
        data[column] = this.edit_data[column];
      }.bind(this));

      var response = await this.storage.update(this.container.split("|")[1], this.edit_data["id"], data);

      if (response.status_code === 200) {
        Notifications.show("The row has been updated.");

        this.load();
        this.d_edit_data = false;
      } else {
        Notifications.show(response.message);
      }

      this.l_edit = false;
    },
    back() {
      this.$router.go(-1);
    }
  },
  components: {
    FilterContainer
  }
};
</script>

<style>
</style>